import * as React from 'react';

interface IUseInterval {
  cb: () => void;
  delay: number | null;
}

export const useInterval = (args: IUseInterval) => {
  const idCallback = React.useRef<any>();
  const savedCallback = React.useRef<any>();

  React.useEffect(() => {
    savedCallback.current = args.cb;
  }, [args.cb]);

  React.useEffect(() => {
    idCallback.current = null;

    const tick = () => {
      savedCallback.current();
    };

    if (args.delay !== null) {
      idCallback.current = setInterval(tick, args.delay);
      return () => clearInterval(idCallback.current);
    } else {
      if (idCallback.current) {
        clearInterval(idCallback.current);
      }
    }
  }, [args.delay]);
};
